export const INJECT_RECOMMENDED_POSTS = '[recommendedPosts] inject recommended posts'

export function injectRecommendedPostsToPostPage(posts) {
  return {
    type: INJECT_RECOMMENDED_POSTS,
    state: {
      posts,
    },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedPosts/recommendedPosts.actions.js